import { InvoiceStatus } from '../enums/invoiceStatus'

export const invoiceStatusToTitleKey: Record<InvoiceStatus, string> = {
  [InvoiceStatus.All]: 'external_invoices.category.all',
  [InvoiceStatus.Credited]: 'external_invoices.category.credited',
  [InvoiceStatus.Deleted]: 'external_invoices.category.deleted',
  [InvoiceStatus.Draft]: 'external_invoices.category.draft',
  [InvoiceStatus.Open]: 'invoices',
  [InvoiceStatus.Overdue]: 'external_invoices.category.overdue',
  [InvoiceStatus.Paid]: 'external_invoices.category.paid',
  [InvoiceStatus.PartiallyCredited]: 'external_invoices.category.partially_credited',
  // the title translation keys for the invoice statuses below
  // should be revised while working on the Invoices List revamp
  [InvoiceStatus.Reminded]: 'invoices',
  [InvoiceStatus.Sent]: 'invoices',
  [InvoiceStatus.Unpaid]: 'external_invoices.category.unpaid',
  [InvoiceStatus.Unsent]: 'external_invoices.category.unsent',
}
